import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    display: 'flex',
    width: '100%',
    margin: 0
  },
  itemContainer: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3, 0),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 1.5)
    }
  }
}))

const PageContent: React.FC = ({ children }) => {
  const classes = useStyles()

  return (
    <div className={classes.content}>
      <Container maxWidth={false}>{children}</Container>
    </div>
  )
}

export const PageRecordItemContent: React.FC = ({ children }) => {
  const classes = useStyles()

  return (
    <Container maxWidth={false} className={classes.itemContainer}>
      {children}
    </Container>
  )
}

export default PageContent
